import { FailedResp } from '@paradigm/api/src';

const DEFAULT_FAILED_RESP = {
  ok: false,
  status: 1,
  error: '',
  message: '',
  data: {},
} as const;

export function createFailedResp(message: string): FailedResp {
  return {
    ...DEFAULT_FAILED_RESP,
    message,
  };
}
